/**
 * Compact product type scale. Body copy is `text-xs/relaxed` (set by primitives);
 * use these for headings, metrics, and meta text instead of ad hoc size/weight pairs.
 *
 * Page title (h1) → PageWrapper only
 * Section title (h2) → `Section`
 * Subsection title (h3) → nested `Section headingLevel={3}` or inline group labels
 * Card title → `CardTitle` (already `text-sm font-medium`; do not override)
 */
export const pageTitleClassName = "text-foreground truncate text-base font-semibold sm:text-lg";

export const sectionTitleClassName = "text-sm font-semibold";

export const subsectionTitleClassName = "text-xs/relaxed font-semibold";

export const statValueClassName = "text-lg font-semibold tabular-nums";

export const metaTextClassName = "text-muted-foreground text-xs/relaxed";
